import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { usersReducer } from './reducers/usersReducer'
import { origensReducer } from './reducers/origensReducer'
import { machineriesReducer } from './reducers/machineriesReducer'
import { cropsReducer } from './reducers/cropsReducer'
import { productsReducer } from './reducers/productsReducer'
import { laborsReducer } from './reducers/laborsReducer'
import { farmsReducer } from './reducers/farmsReducer'
import { plotsReducer } from './reducers/plotsReducer'
//import { campaignsReducer } from './reducers/campaignsReducer'
import { cardsReducer } from './reducers/cardsReducer'
import { cardsauxReducer } from './reducers/cardsauxReducer'
import { countersReducer } from './reducers/countersReducer'
import { logsReducer } from './reducers/logsReducer'

const intialState = {}
const appReducer = combineReducers({
    users: usersReducer,
    origens: origensReducer,
    machineries: machineriesReducer,
    crops: cropsReducer,
    products: productsReducer,
    labors: laborsReducer,
    plots: plotsReducer,
    //campaigns: campaignsReducer,
    farms: farmsReducer,
    cards: cardsReducer,
    cardsaux: cardsauxReducer,
    counters: countersReducer,
    logs: logsReducer
})

const reducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducer, intialState, composeEnhancer(applyMiddleware(thunk)))

export default store